/**
 * menu-supervisor.js
 */

import React from 'react';
import Icon from 'components/icon';

export default [
  { title: 'Records', route: '/records', icon: <Icon type='records' />, disableIE: true },
  { title: 'Manage', route: '/manage', icon: <Icon type='group' /> },
  { title: 'Vaccines', route: '/vaccines', icon: <Icon type='vaccination' /> },
  { title: 'Profile', route: '/profile', icon: <Icon type='profile' /> }, 
  { title: 'Billing', route: '/billing', icon: <Icon type='billing' /> },
];